import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').controller('MarketMessageCtrl', MarketMessageCtrl);

    function MarketMessageCtrl($routeParams, MarketsMessages, DATES) {
        var vm = this;

        vm.DATES = DATES;
        vm.uiLoading = true;
        vm.uiLoadingError = false;
        vm.getMessage = getMessage;

        getMessage();

        function getMessage() {
            MarketsMessages.details(
                {
                    messageId: $routeParams.messageId
                },
                function (res) {
                    vm.marketMessage = res;
                    vm.uiLoading = false;
                },
                function () {
                    vm.uiLoading = false;
                    vm.uiLoadingError = true;
                }
            );
        }
    }
})();
